import React from 'react';
import ViewExpenseComponent from '../../../Components/Expense/ViewExpense';

export default function ViewExpense() {
    return (
        <div className='page-body'>
            <ViewExpenseComponent />
        </div>
    );
}